export enum SimplexResultType {
  Failed = 'failed',
  Paused = 'paused',
  Skipped = 'skipped',
  Solved = 'solved',
}
